import { createContext,  useEffect, useState } from 'react';
import { Combo, CombosResponse, ComboResponse } from '../../models/interfaces';
import topApi from '../../components/api/ToPApi';




type CombosContextProps = {
    combos: Combo[];
    totalPage: number;
    loadCombos: (productId: number) => Promise<void>;
    addCombo: ( combo: Combo ) => Promise<string>;
    updateCombo: ( productId: number, stockId:number, combo:Combo ) => Promise<string>;
    deleteCombo: ( productId: number, stockId:number ) => Promise<string>;

}



export const CombosContext = createContext({} as CombosContextProps);

export const CombosProvider = ({ children }: any) => {

    const [combos, setCombos] = useState<Combo[]>([]);    
    const [totalPage, setTotalPage] = useState<number>(0);
    const pageSize = 25;



    const loadCombos = async (productId) => {

        const resp = await topApi.get<CombosResponse>('/combo/getComboByProductId/'+productId);
        if(resp.status == 200){
            setCombos([...resp.data.combos]);
            setTotalPage(1);
        }


    }

    const addCombo = async (combo: Combo)  => {
        try {
            const resp = await topApi.post<ComboResponse>('/combo/', { combo });
            setCombos([...combos, resp.data.combo]);
            return 'success'
            
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }
    

    const updateCombo = async (productId: number, stockId:number, combo:Combo) => {
        try {
            const resp = await topApi.put<Combo>(`/combo/${productId}/${stockId}`, { combo });
            
            const updateCombo = resp.data["combo"];
                setCombos(combos.map(prod => {   
                    if(prod.productId === productId && prod.stockId === stockId)
                        prod.quantity = updateCombo.quantity;
                    return prod; 
                }));
            
            return 'success'
            
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
        
        
    }

    const deleteCombo = async (productId: number, stockId:number) => {
        try {
            await topApi.delete<Combo>(`/combo/${productId}/${stockId}`);
            setCombos((prevCombos) =>
                prevCombos.filter((combo) => combo.productId !== productId || combo.stockId !== stockId)
            );
            return 'success'
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }       
    }

   

    return (
        <CombosContext.Provider value= {{ combos, totalPage, loadCombos, addCombo, updateCombo, deleteCombo}}>
            { children }
        </CombosContext.Provider>
    );
}